const dictionary = {
  'These credentials do not match our records.': 'Эти учетные данные не соответствуют нашим записям.',
  'The email has already been taken.': 'Такой email уже используется.',
  'The selected email is invalid.': 'Выбран неверный адрес электронной почты.',
  'The phone must be a number.': 'Телефон должен содержать только цифры.',
  'The phone may not be greater than 79999999999.': 'Телефон должен быть в таком формате 79999999999.',
  'The phone must be at least 79000000000.': 'Телефон должен быть в таком формате 79000000000.',
  'The initial message field is required.': 'Поле с начальным сообщением обязательно.'
}

export default function (message) {
  return dictionary[message] || message
}
